// javascript/controllers/cart_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["fullSidebar"]

  static toggleClasses = ['translate-x-0 ease-out', 'translate-x-full ease-in']
  connect() { }

  toggleOpen() {
    if (this.fullSidebarTarget.classList.contains('translate-x-0')) {
      this.fullSidebarTarget.classList.remove('translate-x-0', 'ease-out')
      this.fullSidebarTarget.classList.add('translate-x-full', 'ease-in')
    } else {
      this.fullSidebarTarget.classList.remove('translate-x-full', 'ease-in')
      this.fullSidebarTarget.classList.add('translate-x-0', 'ease-out')
    }
    // this.element.classList.toggle("hidden")
  }
}